<style lang="scss" scoped>
.gift-message-element__image {
  max-width: 250px;

  img {
    max-width: 100%;
  }

  .no-image {
    color: #fff;
    display: flex;
    justify-content: center;
    align-items: center;
    width: 250px;
    height: 250px;
  }
}

.invalid-feedback {
  display: block;
}
</style>

<template>
  <div>
    <div class="rounded bg-secondary gift-message-element__image">
      <img v-if="value" :src="`/api/v1/gift/${value}`" />
      <div class="no-image" v-else>
        Kein Geschenk ausgewählt
      </div>
    </div>
    <div @click="$modal.show(modalName)" class="btn btn-secondary">
      Geschenk auswählen
    </div>
    <div
      v-if="hasErrors"
      v-for="(error, index) in attributeErrors"
      :key="index"
      class="invalid-feedback"
    >
      <div v-for="e in error" :key="e">
        {{ e }}
      </div>
    </div>
    <modal
      width="80%"
      height="auto"
      :pivot-y="0.1"
      :adaptive="true"
      resizable
      draggable
      scrollable
      :name="modalName"
    >
      <gift-select :name="modalName" @send-gift="emitGift"></gift-select>
    </modal>
  </div>
</template>

<script lang="babel">
import GiftSelect from '@/components/GiftSelect.vue';

export default {
  components: {
    GiftSelect
  },
  props: {
    value: {
      required: true,
    },
    attributeErrors: {
      type: Array
    },
    index: {
      type: Number
    }
  },
  data() {
    return {
      modalName: 'gift-' + this.index
    };
  },
  computed: {
    hasErrors() {
      return this.attributeErrors !== null && this.attributeErrors.length !== 0;
    }
  },
  methods: {
    emitGift(id) {
      this.$emit('input', id);
    }
  }
}
</script>
